export default class Util {

    static setupLabelPositionAdjuster($scope = null) {
        if (! $scope) {
            $scope = $('body');
        }
        Util.adjustLabelPositions($scope);
        Util.setupDirtyLabelHandler($scope);
    }

    static setupDirtyLabelHandler($scope) {
        let resizeIsRunning = false;
        let resizeTimer = null;
        let killResizeTimer = null;

        $(window).on("change resize", function() {

            // Strategy: We run the label resize code every 50ms as long as resize events continue to fire.
            // When no resize events have fired for a while, stop resizing labels.

            if ( ! resizeIsRunning) {
                Util.adjustLabelPositions($scope); // resize once
                resizeTimer = setInterval(function() {
                    Util.adjustLabelPositions($scope);
                }, 50); // Resize labels again every 50 ms
                resizeIsRunning = true;
            }

            clearTimeout(killResizeTimer);
            killResizeTimer = setTimeout(function() {
                clearTimeout(resizeTimer);
                resizeIsRunning = false;
            }, 200);
        });
    }

    static adjustLabelPositions($scope) {
        $scope.find("form.form-horizontal .form-group label.control-label:visible").each(function() {
            let jStartSpan = $('<span style="font-size:1px">&nbsp;</span>');
            let jEndSpan = $('<span style="font-size:1px">&nbsp;</span>');
            $(this).prepend(jStartSpan);
            $(this).append(jEndSpan);
            if (jStartSpan.offset().top != jEndSpan.offset().top) {
                $(this).parent('.form-group').addClass('multi-line');
            } else {
                $(this).parent('.form-group').removeClass('multi-line');
            }
            jStartSpan.remove();
            jEndSpan.remove();
        });
    }

    static makeBareSlug(trueSlug) {
        let separator = '----';
        if (!trueSlug) return trueSlug;
        let separatorPosition = trueSlug.indexOf(separator);
        if (separatorPosition < 0) return trueSlug;
        return trueSlug.substring(separatorPosition + separator.length);
    }

    static getHasManyTemplate(templateHtml, curIndex) {
        return templateHtml.replace(new RegExp("{{row-index}}", "g"), curIndex);
    }

    static safeIntVal(jEl, emptyVal) {
        if (typeof emptyVal === 'undefined') {
            emptyVal = 0;
        }
        if (!jEl.length) {
            return emptyVal;
        }
        let val = parseInt(jEl.val().match(/\d+/), 10);
        return isNaN(val) ? emptyVal : val;
    }

    static urlEncode(uri) {
        return encodeURIComponent(uri);
    }

    /**
     * Set the values for any :inputs that have names matching the keys in the json parameter.
     *
     * @param {int} json - A single row of data, represented as an object like { field_name: field_value, ... }
     * @param {boolean} [allowHidden=false] Whether to allow setting hidden inputs, defaults to false.
     */
    static setFromJson(json, allowHidden) {
        let selects = [];

        allowHidden = allowHidden || false;

        $('.webform input[type="checkbox"]').prop('checked', false).change(); // clear checkboxes
        /* clear other fields if in participants or researchers module otherwise entries for network
           module will be cleared after selecting a new entry */
        if ($('body').hasClass('module_participants') || $('body').hasClass('module_researchers')) {
            $('.webform textarea').val('');
            $('.webform input[type="text"]').val('');
            $('.webform select').val('').change();
        }

        $.each(json, function(name, value) {
            name = name.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&"); // escape special chars
            let jElements = $('[name=' + name + ']').not('.print-only');

            // handle status checkboxes
            if (!jElements.length && name === 'statuses' && value) {
                let values = value.split(',');
                let escValue, i;
                for (i = 0; i < values.length; i++) {
                    escValue = 'project_status[' + values[i] + ']';
                    escValue = escValue.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
                    jElements = $('[name=' + escValue + ']').not('.print-only');
                    if (!allowHidden) {
                        jElements = jElements.not('[type=hidden]');
                    }
                    jElements.first().prop("checked", value ? true : false).change();
                }
                return true;
            }

            if ( ! allowHidden) {
                jElements = jElements.not('[type=hidden]');
            }
            let jElement = jElements.first();
            if (!jElement.length) return true; // continue loop -- strange jQuery.each syntax
            switch (jElement.attr('type')) {
                case 'radio':
                    jElements.filter('[value=' + value + ']').prop('checked', true).change(); // show dependent inputs
                    break;
                case 'checkbox':
                    jElement.prop("checked", value ? true : false).change();
                    break;
                default: // text, select, textarea
                    if (!jElement.is('select')) {
                        if(value && jElement.is('.tt-input')) {
                            jElement.typeahead('val', value);
                        }
                        else {
                            jElement.val(value);
                        }

                        if (value && jElement.is('.datepicker')) {
                            jElement.pikaday('setDate', moment(jElement.val()).format('MM/DD/YYYY'));
                        }
                    }
                    else {
                        selects.push([name, value]);
                    }
                    break;
            }
        });
        // Sometimes checkboxes are a prerequisite for a selection to be active. So defer the select2 completion until
        // all checkboxes have been filled in. This is needed for certain selects such as the DAISY Primary Initiative Field.
        selects.forEach(function(sid) {
            let jElements = $('[name=' + sid[0] + ']').not('[type=hidden]').not('.print-only');
            let jElement = jElements.first();
            if (!jElement.length) return true;
            jElement.val(sid[1]).change(); // needed for select2 updating
        });
    }

    static assignCompletion(fieldNames, path) {
        fieldNames.forEach(function(eid) {
            $('#' + eid).typeahead({}, {
                name: eid,
                displayKey: eid,
                source: function(query, sync, async) {
                    // Pass through the selected publication type to the ajax controller.
                    let type = Util.makeBareSlug($('#type').val());
                    //Encode the query.
                    query = Util.urlEncode(query);
                    //Check for blank queries.
                    if (query != '') {
                        $.ajax(window['public_path'] + '/' + path + '/search/' + query,
                            {dataType: 'json', data: {eid: eid, type: type}})
                            .success(function(result) {
                                async(result);
                            });
                    }
                },
                templates: {
                    suggestion: function(t) {
                        return '<div><div class="name">' +
                            (t.title || t.activity || t.organization || t.proposal_title || '') +
                            '</div><div class="email">' + (t.authors || t.investigators || t.inventor || '') + '</div></div>';
                    }
                }
            }).on('typeahead:select typeahead:autocomplete', function(e, datum) {
                Util.setFromJson(datum);
            });
        });
    }

    static devTool(id, html) {
        let jDev = $('#dev');
        let jToolDiv = jDev.find('#' + id);

        if (Util.isDeveloper()) {
            if ( ! jToolDiv.length) {
                jDev.append('<div id="' + id + '"></div>')
                jToolDiv = jDev.find('#' + id);
            }
            jToolDiv.html(html);
        }
    }

    static isDeveloper()
    {
        return Util.can('use_developer_tools');
    }

    static can(permission) {
        return $('body').hasClass('perm_' + permission);
    }

    /**
     * @param string
     * @returns {string}
     */
    static htmlEscape(string) {
        // List of HTML entities for escaping.
        let htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '/': '&#x2F;'
        };
        // Regex containing the keys listed immediately above.
        let htmlEscaper = /[&<>"'\/]/g;
        // Escape a string for HTML interpolation.
        return ('' + string).replace(htmlEscaper, function(match) {
            return htmlEscapes[match];
        });
    }
}
